export default "__VITE_ASSET__8b68bb87__"